import { EditButton } from '../../../../../global';
import { ButtonIcon, Tag as TagComponent } from '../../../../../components';
import { GLOBAL_ICONS } from '../../../../../util/vars';
import type { TagProps } from '../../../../../components/tag/Tag';

interface Props {
  abbreviation: string;
  color: TagProps['color'];
  handleEdit: () => void;
  handleDelete?: () => void;
  children: string;
}

const Tag = ({
  abbreviation,
  color,
  handleDelete,
  handleEdit,
  children,
}: Props): JSX.Element => {
  return (
    <div className={'flex items-center space-x-3'}>
      <TagComponent color={color}>{abbreviation}</TagComponent>
      <p>{children}</p>
      <EditButton onClick={handleEdit} />
      {handleDelete
        ? (
          <ButtonIcon
            icon={GLOBAL_ICONS.delete}
            isCircle
            isOutline
            color={'light'}
            size={'sm'}
            onClick={handleDelete} />
        )
        : null}
    </div>
  );
};

export default Tag;
